import { Component, OnInit, ViewChild, ElementRef, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import ReactDOM from 'react-dom';
import { Modal } from '@dfds-ui/modal';
import React, { useRef, useLayoutEffect, useState } from 'react';
import styled from '@emotion/styled';


@Component({
    selector: 'sbw-popup2',
    template: `
        <span #react></span>
        <template #template>
            <span>
                <ng-content></ng-content>
            </span>
        </template>`
})
export class Popup2Component implements OnInit, OnDestroy {

    @ViewChild('react', { static: true }) react: ElementRef
    @ViewChild('template', { static: true }) template: ElementRef

    @Input() heading
    @Input() closable = false
    @Output() closing = new EventEmitter()

    private setOpen: (boolean) => void


    ngOnInit() {
        const StyledModal = styled(Modal)`
            z-index: 200;
            button {
                background-color: white;
                display: ${this.closable ? 'block' : 'none'};
            }`

        //we render ng-content to another element outside of react since we cannot use ng-content in react
        //we then move it into react in a hook
        //we save the element here because it will be gone once we do appendChild
        const element = this.template.nativeElement.children[0]
        const NgContent = () => {
            const target = useRef(null)
            useLayoutEffect(() => { target.current.appendChild(element) })
            return <div ref={target}></div>
        }

        const Popup2 = () => {
            const [isOpen, setOpen] = useState(true)
            this.setOpen = setOpen
            const [heading, setHeading] = useState(this.heading)
            this.setHeading = setHeading
            return <StyledModal backdrop="highEmphasis" onRequestClose={() => this.closing.emit()} heading={heading} isOpen={isOpen}><NgContent /></StyledModal>
        }

        ReactDOM.render(<Popup2 />, this.react.nativeElement)
    }

    setHeading = _ => { }

    ngOnDestroy() {
        this.setOpen(false)
    }

}
